
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparSphere as ObiBuoySparSphereElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-sphere.js';
 
 
 

 
 export const ObiBuoySparSphere = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-sphere',
   elementClass: ObiBuoySparSphereElement,
   events: {
     
   }
  });
 
 